import React, { createContext, useContext } from "react";
import { PartnerStore } from "../Stores/PartnerStore";
import { CaregiverStore } from "../Stores/CaregiverStore";
import { DocumentInfoStore } from "../Stores/DocumentStore";
import { IAgeReadyContext } from "./IAgeReadyContext";

const createContextDependencies = (): IAgeReadyContext => {
  const caregiverStore = CaregiverStore.create({
    isLoading: false,
    partnerCode: "",
    caregiverId: "",
    isAdmin: false,
  });

  const documentInfoStore = DocumentInfoStore.create({
    isLoading: false,
    infoItems: [],
    tableHeaders: ['Type', 'FileName', 'Domain', 'Uploaded'],
    uploadMessage: "",
    tableMessage: ""
  });

  const partnerStore = PartnerStore.create({
    isLoading: false,
    logosByPartnerId: {},
    partnersByIdMap: {}
  });

  return {
    caregiverStore,
    documentInfoStore,
    partnerStore
  };
};

export const contextDependencies = createContextDependencies();

export const RecipientServiceContext = createContext(contextDependencies);

export const useAgeReadyContext = (): IAgeReadyContext => {
  return useContext(RecipientServiceContext);
};

export const AgeReadyContext: React.FC = (props) => {
  return (
    <RecipientServiceContext.Provider value={contextDependencies}>
      {props.children}
    </RecipientServiceContext.Provider>
  );
};
